import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';

import ErrorReporter from 'app/components/ErrorReporter';
import VideoChatMessageInviteItem from 'chat/components/VideoChatMessageInviteItem';
import { SequenceItem } from '../chunker';

type Props = {
  items: Array<SequenceItem>;
};

class VideoChatMessageInviteItems extends React.Component<Props, void> {
  isAuthor() {
    const { item } = this.props.items[0];
    if (item.__typename !== 'VideoChatMessageInviteItem') {
      return (
        <ErrorReporter error="VideoChatMessageInviteItems - tried to render with non-messages" />
      );
    }
    return CurrentUser.getUserUuid() === item.sender.uuid;
  }

  render() {
    if (this.props.items.length <= 0) {
      return null;
    }

    return (
      <div
        className={cx('MessageItems', {
          'MessageItems-self': this.isAuthor(),
          'MessageItems-other': !this.isAuthor(),
        })}>
        {this.props.items.map((item, index) => {
          const inviteItem = item.item;
          if (inviteItem.__typename !== 'VideoChatMessageInviteItem') {
            return (
              <ErrorReporter error="VideoChatMessageInviteItems - tried to render with non-messages" />
            );
          }
          return (
            <VideoChatMessageInviteItem
              key={item.key}
              message={inviteItem}
              lastOfGroup={index === this.props.items.length - 1}
            />
          );
        })}
      </div>
    );
  }
}

export default VideoChatMessageInviteItems;
